import { openDialog } from '@patrianna/dialog-manager'

import type { TypedThunk } from 'store/types'

import { getPendingDialogSelector } from './selectors'
import { actions } from './slice'

export const { toggleMenu, setPendingDialog, clearPendingDialog } = actions

export const openPendingDialogIfExists = (): TypedThunk => (dispatch, getState) => {
  const pendingDialog = getPendingDialogSelector(getState())

  if (pendingDialog) {
    openDialog({
      dialogName: pendingDialog.dialogName,
      dialogProps: pendingDialog.dialogProps,
    })
    dispatch(clearPendingDialog())
  }
}
